/* ADVERTISEMENT_LIVES */
export const GET_ADVERTISEMENT_LIVES = "GET_ADVERTISEMENT_LIVES";
export const GET_ADVERTISEMENT_LIVES_SUCCESS = "GET_ADVERTISEMENT_LIVES_SUCCESS";
export const GET_ADVERTISEMENT_LIVES_FAIL = "GET_ADVERTISEMENT_LIVES_FAIL";
